(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["merge-material-care-product-tab"] && !Shopify.designMode) return;
  try {
    (function initMergeCareData(root, factory) {
  const value = factory();
  if (typeof module === 'object' && module.exports) module.exports = value;
  else root.MergeCareData = value;
}(typeof globalThis !== 'undefined' ? globalThis : this, function createData() {
  const categories = [
    { id: 'metals', label: 'Metals' },
    { id: 'glass-crystal', label: 'Glass & Crystal' },
    { id: 'stone-mineral', label: 'Stone & Mineral' },
    { id: 'natural', label: 'Natural Materials' },
    { id: 'textiles-shades', label: 'Textiles & Shades' },
    { id: 'ceramic-specialty', label: 'Ceramic & Specialty' },
  ];

  const finishes = [
    { id: 'lacquered', label: 'Lacquered' },
    { id: 'unlacquered', label: 'Unlacquered (Living Finish)' },
    { id: 'plated', label: 'Plated' },
    { id: 'patinated', label: 'Patina / Antiqued' },
    { id: 'brushed', label: 'Brushed / Satin' },
    { id: 'polished', label: 'Polished' },
    { id: 'powder-coated', label: 'Powder-Coated' },
    { id: 'painted', label: 'Painted' },
    { id: 'pvd', label: 'PVD Protective Finish' },
  ];

  const finishNotes = {
    lacquered: 'The clear coating protects the metal. Do not use metal polish. Stop if the coating looks cloudy, chipped, or begins to lift.',
    unlacquered: 'Use a dry cloth only unless Merge confirms another method. Natural oxidation and patina are normal; do not polish them away.',
    plated: 'Plating is a thin decorative layer. Wipe gently. Do not use metal polish, ammonia, acid, or abrasive cleaners.',
    patinated: 'The color variation is intentional. Do not use polish, oil, or repeated rubbing to make the finish look even.',
    brushed: 'Wipe gently in the direction of the grain. Rubbing in circles can create visible patches and cross-grain marks.',
    polished: 'Remove loose dust first. Then use a perfectly clean, soft cloth to reduce fine scratches and haze.',
    'powder-coated': 'Start with a dry cloth. If the coating is intact, use a slightly damp cloth and dry the surface immediately.',
    painted: 'Treat paint as a delicate coating. Avoid solvents, alcohol, abrasive cleaners, and heavy rubbing near edges.',
    pvd: 'PVD is a durable protective coating, but abrasive particles and harsh chemicals can still damage it. Use a soft, dry cloth and no metal polish.',
  };

  const universalSafety = [
    'Turn off power at the wall switch and circuit breaker before cleaning.',
    'Allow the fixture and light bulb to cool completely.',
    'Never spray liquid directly onto a fixture.',
    'Keep moisture away from electrical parts, joints, and adhesives.',
    'Support removable parts and contact a licensed electrician or qualified installer for hardwired, high, heavy, or fragile fixtures.',
  ];

  const careProfiles = {
    'soft-living-metal': {
      routine: 'Remove dust and fingerprints with a clean, dry, lint-free microfiber cloth. Wipe gently in the direction of any brushed grain.',
      marks: 'For lacquered metal only, use a slightly damp cloth and dry immediately. For an unlacquered finish, stop if a dry cloth does not remove the spot.',
      avoid: 'Do not use metal polish, abrasive pads, acids, vinegar, ammonia, alcohol, solvents, or chemically treated cloths.',
      ageing: 'Unlacquered and patina finishes develop natural color variation and a deeper patina over time. Do not polish away these expected changes.',
      caution: 'If you do not know the finish, use a dry cloth only. Contact Merge before using water or cleaner.',
    },
    'coated-ferrous-metal': {
      routine: 'Dust with a soft, dry cloth, paying attention to seams where moisture and residue can collect.',
      marks: 'On intact painted or powder-coated surfaces, use a slightly damp cloth. Dry the area immediately and completely.',
      avoid: 'Do not use abrasives, metal polish, bleach, solvents, or prolonged moisture. Never use liquid on chipped or blistered coating.',
      ageing: 'Slight color changes may be normal. Rust, peeling coating, or sharp exposed edges need professional inspection.',
      caution: 'Keep water away from joints and damaged coating. Contact Merge if corrosion or coating failure is visible.',
    },
    'plated-polished-metal': {
      routine: 'Dust with an exceptionally soft, clean cloth. Remove fingerprints with gentle straight strokes instead of rubbing in circles.',
      marks: 'Use a slightly damp cloth only when necessary. Gently dry with a second clean cloth without applying steady pressure.',
      avoid: 'Do not use metal polish, glass cleaner, ammonia, acids, abrasives, or repeated rubbing that can thin or cloud the plating.',
      ageing: 'Fine hairline marks and subtle color changes may develop with handling. Peeling, pitting, or discoloration beneath the finish is not normal aging.',
      caution: 'Plating is a thin decorative finish, not solid metal. Stop if any color transfers to the cloth.',
    },
    'clear-decorative-glass': {
      routine: 'Support the glass securely while dusting with a soft microfiber cloth or a clean, natural-bristle brush.',
      marks: 'Remove the glass only if the product guide allows it. Apply a small amount of ammonia-free glass cleaner to the cloth, never directly to the glass or fixture. Dry completely before reinstalling.',
      avoid: 'Do not use abrasive pads, razor blades, strong solvents, sudden temperature changes, or liquid near metal parts, adhesives, and electrical components.',
      ageing: 'Small waves, bubbles, and inclusions are normal characteristics of handmade and seeded glass.',
      caution: 'Have a qualified installer handle heavy, overhead, or difficult-to-remove glass.',
    },
    'matte-etched-glass': {
      routine: 'Use a clean, dry microfiber cloth or a very soft brush. Handle the glass with clean, dry hands to keep oils off the matte surface.',
      marks: 'Blot the spot with a slightly damp, lint-free cloth. Use distilled water when possible, and let the surface dry evenly.',
      avoid: 'Do not use glass polish, oily cleaners, abrasive cloths, or heavy rubbing. These can create shiny patches on a matte or etched surface.',
      ageing: 'Small differences in translucency and texture are normal results of hand finishing, not stains.',
      caution: 'Test water on a hidden area first. Keep all liquid away from attached metal parts and adhesives.',
    },
    'porous-stone': {
      routine: 'Dust with a clean, soft, dry cloth. Support thin stone panels and avoid pressure at edges, veins, and pierced details.',
      marks: 'Blot spills immediately with a dry, absorbent cloth. Use a slightly damp cloth only if the product guide confirms that the stone is sealed, then dry immediately.',
      avoid: 'Do not use acids, vinegar, bleach, alkaline cleaners, oil, polish, abrasive powder, steam, or prolonged contact with water.',
      ageing: 'Veining, translucency, pores, and color variation are natural. Pale stone may develop a slightly warmer tone over time.',
      caution: 'Porous stone can stain permanently. Do not use home stain-removal treatments on a light fixture.',
    },
    'sealed-stone': {
      routine: 'Dust with a soft, dry cloth. Do not drag grit across polished areas.',
      marks: 'Blot spills promptly. If the sealer is intact, use a product-approved, pH-neutral cleaner sparingly on the cloth. Wipe again with a clean, damp cloth and dry the surface.',
      avoid: 'Do not use acids, vinegar, bleach, abrasive powders, scale removers, furniture polish, or colored oils.',
      ageing: 'Natural veins, fossils, pores, and color variation are expected. Contact Merge about etching, dark wet-looking patches, or cracks.',
      caution: 'Stone sealers vary. If you do not know the sealer, use a dry cloth only and contact Merge.',
    },
    'wood-veneer': {
      routine: 'Dust with a soft, dry cloth, following the grain. Keep the fixture away from ongoing moisture, strong heat, and direct sunlight when possible.',
      marks: 'Blot spills immediately. On a known sealed finish, use a slightly damp cloth and dry at once. Do not soak joints or veneer edges.',
      avoid: 'Do not use silicone polish, wax, oil, alcohol, solvents, steam, or abrasive cleaners unless the product guide approves them.',
      ageing: 'Wood naturally changes color over time. Differences in grain and color are expected.',
      caution: 'Contact Merge about lifting veneer, open joints, or water rings. Do not add more moisture or attempt to refinish the area.',
    },
    'woven-natural': {
      routine: 'Support the weave from behind while removing dust with a soft brush or a vacuum on low suction with a clean upholstery attachment.',
      marks: 'Blot dry spills immediately without rubbing. Contact Merge before using water on rattan, cane, or other woven natural fibers.',
      avoid: 'Do not soak, steam, scrub, bleach, or pull loose fibers. Avoid household sprays that leave a sticky residue.',
      ageing: 'Natural fibers can become warmer in color and show small differences in width, texture, and weave tension.',
      caution: 'Stop handling the fixture if the weave is brittle, broken, or loose. Contact Merge for guidance.',
    },
    'delicate-textile': {
      routine: 'Dust gently with a clean, soft brush or a vacuum on low suction through protective mesh. Turn the shade carefully without touching the bulb socket.',
      marks: 'For a fresh spot, blot gently from both sides with a white, absorbent cloth. Ask a textile specialist to treat any spot that remains.',
      avoid: 'Do not wet-clean, rub, use stain remover, bleach, steam, or apply adhesive lint rollers to delicate shades.',
      ageing: 'Small variations in yarn thickness, weave, and color are normal. Light exposure may gradually change the color.',
      caution: 'Turn off power. Remove the shade only when the product guide explains a simple and safe method.',
    },
    'washable-textile': {
      routine: 'Use a soft brush or low-suction vacuum with a clean upholstery attachment. Work from top to bottom without pressing the fabric inward.',
      marks: 'Blot promptly with a white, absorbent cloth. Use water only when the product care label explicitly permits spot cleaning.',
      avoid: 'Do not saturate, scrub, machine wash, bleach, steam, or use colored cloths that may transfer dye.',
      ageing: 'Natural fibers may have small variations in yarn thickness and color. Synthetic fabrics may attract dust because of static electricity.',
      caution: 'The outer fabric, trim, adhesives, and inner liner may react differently to water. Start with dry care only.',
    },
    'ceramic-porcelain': {
      routine: 'Dust glazed and unglazed surfaces with a soft, dry cloth or clean brush. Support raised or decorative parts.',
      marks: 'On an intact glazed area, use a slightly damp cloth and dry immediately. Keep unglazed, crackle-glazed, and hand-painted areas dry unless the product guide says otherwise.',
      avoid: 'Do not use abrasives, acids, bleach, soaking, or sudden temperature changes. Never lift a fixture by a ceramic projection.',
      ageing: 'Color variation, tiny pinholes, and intentional crackle patterns are normal characteristics of hand-applied glaze.',
      caution: 'Stop using the fixture and contact Merge if you see a structural crack, loose fitting, or sharp chipped edge.',
    },
    'clear-plastic': {
      routine: 'Remove loose dust first. Then wipe gently with a clean, soft microfiber cloth used only for clear plastic.',
      marks: 'Place a small amount of lukewarm water and product-approved mild soap on the cloth. Wipe again with a clean, damp cloth, then blot dry.',
      avoid: 'Do not use glass cleaner, ammonia, alcohol, acetone, solvents, paper towels, abrasive cloths, or dry rubbing on a dusty surface.',
      ageing: 'Fine handling marks may develop over time. Yellowing, fine surface cracks, or deep cracks need professional inspection rather than polishing.',
      caution: 'Clear plastics react differently to cleaning products. Confirm the exact material before using any soap or cleaner.',
    },
    'resin-lacquer': {
      routine: 'Dust with a soft, lint-free cloth and very light pressure, especially on high-gloss or hand-finished surfaces.',
      marks: 'Use a slightly damp cloth only on an intact finish. Dry immediately with a second soft cloth.',
      avoid: 'Do not use alcohol, acetone, solvents, furniture polish, abrasive cleaners, eraser-style cleaning sponges, or prolonged moisture.',
      ageing: 'Hand-finished resin and lacquer may show subtle color and surface variation. Strong sunlight and heat can change the color over time.',
      caution: 'Stop if the surface becomes sticky, softens, or transfers color. Do not try to polish through scratches.',
    },
    leather: {
      routine: 'Dust with a clean, soft, dry cloth. Keep leather away from repeated moisture, strong heat, and direct sunlight.',
      marks: 'Blot spills immediately with a dry white cloth. Use only a care product approved for the exact leather and finish.',
      avoid: 'Do not use household polish, oil, alcohol, solvents, bleach, abrasive cloths, or soaking.',
      ageing: 'Leather may deepen in color, soften, and develop a natural patina over time. These changes are expected.',
      caution: 'Contact Merge if the leather becomes dry, cracked, loose, or separated from its backing.',
    },
    shell: {
      routine: 'Dust with a clean, soft, dry cloth or brush. Support delicate shell pieces and inlays while cleaning.',
      marks: 'Blot a fresh spot with a dry white cloth. Use water or cleaner only when Merge approves it for the exact finish.',
      avoid: 'Do not use household polish, oil, alcohol, solvents, bleach, abrasive cloths, or soaking.',
      ageing: 'Natural color bands, ridges, and small surface variations make each shell piece unique.',
      caution: 'Stop cleaning and contact Merge if the shell is cracked, chipped, loose, or lifting from its backing.',
    },
    'mother-of-pearl': {
      routine: 'Dust with a clean, soft, dry microfiber cloth and very light pressure. Support delicate inlays while cleaning.',
      marks: 'Blot a fresh spot with a dry white cloth. Do not use water or cleaner unless Merge approves it for the exact finish.',
      avoid: 'Do not use household polish, oil, alcohol, solvents, bleach, abrasive cloths, or soaking.',
      ageing: 'Natural changes in color and iridescence make every mother-of-pearl surface unique.',
      caution: 'Stop cleaning and contact Merge if an inlay is cracked, loose, or lifting from its backing.',
    },
    'concrete-plaster': {
      routine: 'Dust with a very soft, dry brush or cloth. Use light pressure to protect edges and textured surfaces.',
      marks: 'Blot dry spills or residue without rubbing. Use a slightly damp cloth only when the product is confirmed sealed, then dry evenly.',
      avoid: 'Do not soak, scrub, use acids, bleach, colored cleaners, abrasive pads, or attempt local sanding and repainting.',
      ageing: 'Small pores, natural color variation, and hand-applied texture are expected. Fine surface lines may be part of the finish.',
      caution: 'Contact Merge before further cleaning if you see new cracks, crumbling, deep stains, or exposed underlying material.',
    },
  };

  const materials = [
    ['brass', 'Brass', 'metals', ['yellow metal'], 'soft-living-metal', ['lacquered', 'unlacquered', 'plated', 'patinated', 'brushed', 'polished', 'pvd']],
    ['bronze', 'Bronze', 'metals', [], 'soft-living-metal', ['lacquered', 'unlacquered', 'patinated', 'brushed', 'polished']],
    ['copper', 'Copper', 'metals', [], 'soft-living-metal', ['lacquered', 'unlacquered', 'patinated', 'polished']],
    ['steel', 'Steel', 'metals', ['stainless steel'], 'coated-ferrous-metal', ['brushed', 'polished', 'powder-coated', 'painted', 'pvd']],
    ['iron', 'Iron', 'metals', ['wrought iron'], 'coated-ferrous-metal', ['patinated', 'powder-coated', 'painted']],
    ['aluminium', 'Aluminum', 'metals', ['aluminium'], 'plated-polished-metal', ['brushed', 'polished', 'powder-coated', 'painted']],
    ['nickel', 'Nickel', 'metals', [], 'plated-polished-metal', ['plated', 'brushed', 'polished']],
    ['chrome', 'Chrome', 'metals', ['chromium'], 'plated-polished-metal', ['plated', 'polished']],
    ['clear-sheet-glass', 'Clear glass panels', 'glass-crystal', ['clear sheet glass', 'flat glass'], 'clear-decorative-glass', []],
    ['hand-blown-glass', 'Hand-blown glass', 'glass-crystal', ['mouth-blown glass'], 'clear-decorative-glass', []],
    ['opal-glass', 'Opal / milk glass', 'glass-crystal', ['opal glass', 'opaline glass', 'milk glass'], 'matte-etched-glass', []],
    ['frosted-glass', 'Frosted glass', 'glass-crystal', ['matte glass'], 'matte-etched-glass', []],
    ['smoked-glass', 'Smoked or tinted glass', 'glass-crystal', ['smoked glass', 'tinted glass', 'colored glass', 'coloured glass'], 'clear-decorative-glass', []],
    ['ribbed-glass', 'Ribbed or fluted glass', 'glass-crystal', ['reeded glass'], 'clear-decorative-glass', []],
    ['etched-glass', 'Etched glass', 'glass-crystal', ['acid-etched glass'], 'matte-etched-glass', []],
    ['seeded-glass', 'Seeded or bubble glass', 'glass-crystal', ['bubble glass'], 'clear-decorative-glass', []],
    ['crystal', 'Crystal', 'glass-crystal', ['lead crystal'], 'clear-decorative-glass', []],
    ['alabaster', 'Alabaster', 'stone-mineral', [], 'porous-stone', []],
    ['marble', 'Marble', 'stone-mineral', [], 'sealed-stone', []],
    ['travertine', 'Travertine', 'stone-mineral', [], 'porous-stone', []],
    ['limestone', 'Limestone', 'stone-mineral', [], 'porous-stone', []],
    ['onyx', 'Onyx', 'stone-mineral', [], 'porous-stone', []],
    ['quartz', 'Quartz & engineered stone', 'stone-mineral', ['engineered stone'], 'sealed-stone', []],
    ['concrete', 'Concrete', 'stone-mineral', [], 'concrete-plaster', []],
    ['plaster', 'Plaster & gypsum', 'stone-mineral', ['gypsum'], 'concrete-plaster', ['painted']],
    ['solid-wood', 'Solid wood', 'natural', ['timber'], 'wood-veneer', ['lacquered', 'unlacquered', 'painted']],
    ['wood-veneer', 'Wood veneer', 'natural', ['veneer'], 'wood-veneer', ['lacquered', 'unlacquered', 'painted']],
    ['rattan', 'Rattan', 'natural', ['wicker'], 'woven-natural', []],
    ['cane', 'Cane', 'natural', ['cane webbing'], 'woven-natural', []],
    ['leather', 'Leather', 'natural', [], 'leather', []],
    ['shell', 'Shell', 'natural', [], 'shell', []],
    ['mother-of-pearl', 'Mother-of-pearl', 'natural', ['nacre', 'mother of pearl'], 'mother-of-pearl', []],
    ['linen', 'Fabric', 'textiles-shades', ['linen', 'linen shade', 'fabric shade'], 'washable-textile', []],
    ['cotton', 'Cotton', 'textiles-shades', ['cotton shade'], 'washable-textile', []],
    ['silk', 'Silk', 'textiles-shades', ['silk shade'], 'delicate-textile', []],
    ['performance-fabric', 'Performance & synthetic fabrics', 'textiles-shades', ['polyester', 'synthetic fabric'], 'washable-textile', []],
    ['ceramic', 'Ceramic', 'ceramic-specialty', [], 'ceramic-porcelain', ['painted']],
    ['porcelain', 'Porcelain', 'ceramic-specialty', [], 'ceramic-porcelain', ['painted']],
    ['acrylic', 'Acrylic', 'ceramic-specialty', ['perspex', 'plexiglass'], 'clear-plastic', []],
    ['resin', 'Resin', 'ceramic-specialty', [], 'resin-lacquer', ['painted']],
  ].map(([id, name, category, aliases, careProfile, finishIds]) => ({
    id,
    name,
    category,
    aliases,
    careProfile,
    finishIds,
  }));

  return {
    categories,
    finishes,
    finishNotes,
    universalSafety,
    careProfiles,
    materials,
  };
}));

(function initMergeCareCatalog(root, factory) {
  const value = factory();
  if (typeof module === 'object' && module.exports) module.exports = value;
  else root.MergeCareCatalog = value;
}(typeof globalThis !== 'undefined' ? globalThis : this, function createCatalog() {
  function normalise(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[-_/]+/g, ' ')
      .replace(/[^a-z0-9 ]+/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function filterMaterials(materials, query, category) {
    const needle = normalise(query);
    return materials.filter((material) => {
      const categoryMatches = !category || category === 'all' || material.category === category;
      const haystack = normalise([
        material.name,
        material.category,
        ...material.aliases,
        ...material.finishIds,
      ].join(' '));
      return categoryMatches && (!needle || haystack.includes(needle));
    });
  }

  function getMaterial(materials, id) {
    return materials.find((item) => item.id === id) || null;
  }

  function getFinish(finishes, id) {
    return finishes.find((item) => item.id === id) || null;
  }

  return {
    normalise,
    filterMaterials,
    getMaterial,
    getFinish,
  };
}));

(function initMergeCareApp(root, factory) {
  const data = typeof module === 'object' && module.exports
    ? require('./materials.js')
    : root.MergeCareData;
  const catalog = typeof module === 'object' && module.exports
    ? require('./catalog.js')
    : root.MergeCareCatalog;
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  } else {
    root.MergeCareApp = api;
    const start = () => api.init(root.document, root, data, catalog);
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', start);
    else start();
  }
}(typeof globalThis !== 'undefined' ? globalThis : this, function createMergeCareApp() {
  const unknownFinishNote = 'If you do not know the finish, dust with a clean, dry cloth only. Contact Merge before using water or cleaner.';
  const generalCareNote = 'Follow these general instructions unless your product guide lists a special finish, coating, or treatment.';
  let assetBase = '';

  function createInitialState() {
    return {
      query: '',
      category: 'all',
      selectedMaterialId: 'brass',
      selectedFinishId: 'lacquered',
    };
  }

  function isMobileLayout(windowRef) {
    return Boolean(
      windowRef
      && typeof windowRef.matchMedia === 'function'
      && windowRef.matchMedia('(max-width: 760px)').matches
    );
  }

  function getCarePanelStickyTop(documentRef) {
    const stickyHeader = documentRef && documentRef.getElementById('sticky-header');
    if (!stickyHeader || typeof stickyHeader.getBoundingClientRect !== 'function') return 18;
    return Math.max(18, Math.ceil(stickyHeader.getBoundingClientRect().height) + 18);
  }

  function syncCarePanelStickyTop(documentRef) {
    const sectionRoot = documentRef && documentRef.querySelector('.merge-care');
    if (!sectionRoot) return;
    sectionRoot.style.setProperty('--care-sticky-top', `${getCarePanelStickyTop(documentRef)}px`);
  }

  function buildViewModel(data, catalog, state) {
    const materials = catalog.filterMaterials(data.materials, state.query, state.category);
    const selectedMaterial = state.selectedMaterialId
      ? materials.find((item) => item.id === state.selectedMaterialId) || materials[0] || null
      : null;
    const availableFinishIds = selectedMaterial ? selectedMaterial.finishIds : [];
    const selectedFinishId = availableFinishIds.includes(state.selectedFinishId)
      ? state.selectedFinishId
      : availableFinishIds[0] || null;
    const selectedFinish = selectedFinishId
      ? catalog.getFinish(data.finishes, selectedFinishId)
      : null;

    return {
      materials,
      selectedMaterial,
      selectedFinish,
      finishNote: selectedFinish
        ? data.finishNotes[selectedFinish.id]
        : selectedMaterial && !selectedMaterial.finishIds.length
          ? generalCareNote
          : unknownFinishNote,
    };
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function categoryLabel(data, id) {
    const category = data.categories.find((item) => item.id === id);
    return category ? category.label : '';
  }

  function materialSampleFilename(materialId) {
    const refreshedAssets = {
      cotton: 'cotton-v4.webp',
      silk: 'silk-v4.webp',
      ceramic: 'ceramic-v6.webp',
    };

    if (refreshedAssets[materialId]) return refreshedAssets[materialId];
    return `${materialId}-v3d.webp`;
  }

  function asciiPdfText(value) {
    return String(value || '')
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201c\u201d]/g, '"')
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/\u2026/g, '...')
      .normalize('NFKD')
      .replace(/[^\x20-\x7e]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapePdfText(value) {
    return asciiPdfText(value).replace(/([\\()])/g, '\\$1');
  }

  function wrapPdfText(value, maxWidth, fontSize) {
    const words = asciiPdfText(value).split(' ').filter(Boolean);
    const maxCharacters = Math.max(12, Math.floor(maxWidth / (fontSize * 0.52)));
    const lines = [];
    let line = '';

    words.forEach((word) => {
      const candidate = line ? `${line} ${word}` : word;
      if (candidate.length <= maxCharacters) {
        line = candidate;
      } else {
        if (line) lines.push(line);
        line = word;
      }
    });

    if (line) lines.push(line);
    return lines.length ? lines : [''];
  }

  function pdfBytes(value) {
    return new TextEncoder().encode(value);
  }

  function joinPdfBytes(chunks) {
    const length = chunks.reduce((total, chunk) => total + chunk.length, 0);
    const output = new Uint8Array(length);
    let offset = 0;
    chunks.forEach((chunk) => {
      output.set(chunk, offset);
      offset += chunk.length;
    });
    return output;
  }

  function pdfObject(id, body) {
    return pdfBytes(`${id} 0 obj\n${body}\nendobj\n`);
  }

  function pdfStreamObject(id, dictionary, stream) {
    const streamBytes = typeof stream === 'string' ? pdfBytes(stream) : stream;
    return joinPdfBytes([
      pdfBytes(`${id} 0 obj\n<< ${dictionary} /Length ${streamBytes.length} >>\nstream\n`),
      streamBytes,
      pdfBytes('\nendstream\nendobj\n'),
    ]);
  }

  function addPdfText(commands, value, x, y, size, font, color) {
    commands.push(`BT /${font} ${size} Tf ${color} rg 1 0 0 1 ${x} ${y} Tm (${escapePdfText(value)}) Tj ET`);
  }

  function addWrappedPdfText(commands, value, x, y, maxWidth, size, leading, font, color) {
    const lines = wrapPdfText(value, maxWidth, size);
    lines.forEach((line, index) => addPdfText(commands, line, x, y - (index * leading), size, font, color));
    return y - (lines.length * leading);
  }

  function buildPdfFile(pageOneCommands, pageTwoCommands, image) {
    const hasImage = Boolean(image && image.bytes && image.bytes.length);
    const objects = new Map();
    const pageOneResources = `<< /Font << /F1 3 0 R /F2 4 0 R >>${hasImage ? ' /XObject << /Im1 9 0 R >>' : ''} >>`;
    const pageTwoResources = '<< /Font << /F1 3 0 R /F2 4 0 R >> >>';

    objects.set(1, pdfObject(1, '<< /Type /Catalog /Pages 2 0 R >>'));
    objects.set(2, pdfObject(2, '<< /Type /Pages /Kids [5 0 R 6 0 R] /Count 2 >>'));
    objects.set(3, pdfObject(3, '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>'));
    objects.set(4, pdfObject(4, '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>'));
    objects.set(5, pdfObject(5, `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources ${pageOneResources} /Contents 7 0 R >>`));
    objects.set(6, pdfObject(6, `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 612 792] /Resources ${pageTwoResources} /Contents 8 0 R >>`));
    objects.set(7, pdfStreamObject(7, '', pageOneCommands.join('\n')));
    objects.set(8, pdfStreamObject(8, '', pageTwoCommands.join('\n')));

    if (hasImage) {
      objects.set(9, pdfStreamObject(
        9,
        `/Type /XObject /Subtype /Image /Width ${image.width} /Height ${image.height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode`,
        image.bytes,
      ));
    }

    const maxObjectId = hasImage ? 9 : 8;
    const chunks = [pdfBytes('%PDF-1.4\n%MERGE\n')];
    const offsets = new Array(maxObjectId + 1).fill(0);
    let byteLength = chunks[0].length;

    for (let id = 1; id <= maxObjectId; id += 1) {
      const object = objects.get(id);
      offsets[id] = byteLength;
      chunks.push(object);
      byteLength += object.length;
    }

    const xrefOffset = byteLength;
    const xref = [
      `xref\n0 ${maxObjectId + 1}\n`,
      '0000000000 65535 f \n',
      ...offsets.slice(1).map((offset) => `${String(offset).padStart(10, '0')} 00000 n \n`),
      `trailer\n<< /Size ${maxObjectId + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF\n`,
    ].join('');
    chunks.push(pdfBytes(xref));
    return joinPdfBytes(chunks);
  }

  function buildCareGuidePdf({ data, material, selectedFinish, finishNote, image = null, createdOn = '' }) {
    const profile = data.careProfiles[material.careProfile];
    const category = categoryLabel(data, material.category);
    const finishLabel = selectedFinish ? selectedFinish.label : 'General care';
    const pageOne = [];
    const pageTwo = [];
    const walnut = '0.259 0.176 0.110';
    const brass = '0.718 0.541 0.294';
    const rust = '0.529 0.267 0.110';
    const muted = '0.430 0.373 0.318';
    const softWhite = '1 0.996 0.980';
    const pale = '0.961 0.929 0.847';
    const careItems = [
      ['01', 'Routine care', profile.routine],
      ['02', 'Spots & spills', profile.marks],
      ['03', 'Avoid', profile.avoid],
      ['04', 'Natural aging', profile.ageing],
    ];

    pageOne.push(`${softWhite} rg 0 0 612 792 re f`);
    addPdfText(pageOne, 'MERGE', 48, 750, 13, 'F2', walnut);
    addPdfText(pageOne, 'MATERIAL CARE & MAINTENANCE', 382, 750, 8, 'F2', muted);
    pageOne.push(`${brass} RG 1 w 48 733 m 564 733 l S`);
    addPdfText(pageOne, category.toUpperCase(), 48, 701, 9, 'F2', brass);
    const materialTitleSize = material.name.length > 28 ? 17 : material.name.length > 20 ? 21 : 28;
    addPdfText(pageOne, material.name, 48, 669, materialTitleSize, 'F2', walnut);
    addPdfText(pageOne, `Surface finish: ${finishLabel}`, 48, 642, 11, 'F1', muted);

    if (image && image.bytes && image.bytes.length) {
      pageOne.push(`${pale} rg 424 584 140 140 re f`);
      pageOne.push('q 132 0 0 132 428 588 cm /Im1 Do Q');
    } else {
      pageOne.push(`${pale} rg 432 592 132 132 re f`);
      addPdfText(pageOne, 'MATERIAL', 470, 654, 9, 'F2', walnut);
    }

    addPdfText(pageOne, 'FINISH NOTE', 48, 603, 8, 'F2', rust);
    addWrappedPdfText(pageOne, finishNote, 48, 582, 340, 10, 14, 'F1', walnut);
    pageOne.push(`${brass} RG 0.8 w 48 512 m 564 512 l S`);

    careItems.forEach(([number, title, body], index) => {
      const column = index % 2;
      const row = Math.floor(index / 2);
      const x = column ? 318 : 48;
      const top = row ? 303 : 480;
      addPdfText(pageOne, number, x, top, 9, 'F2', brass);
      addPdfText(pageOne, title, x + 28, top, 13, 'F2', walnut);
      addWrappedPdfText(pageOne, body, x + 28, top - 23, 218, 9.5, 13.5, 'F1', muted);
    });

    pageOne.push(`${brass} RG 0.8 w 48 54 m 564 54 l S`);
    addPdfText(pageOne, 'mergelighting.com', 48, 35, 8, 'F1', muted);
    addPdfText(pageOne, createdOn ? `Prepared ${createdOn}` : 'Selected material care guide', 236, 35, 8, 'F1', muted);
    addPdfText(pageOne, '1 / 2', 535, 35, 8, 'F2', walnut);

    pageTwo.push(`${softWhite} rg 0 0 612 792 re f`);
    addPdfText(pageTwo, 'MERGE', 48, 750, 13, 'F2', walnut);
    addPdfText(pageTwo, `${material.name} / ${finishLabel}`, 382, 750, 8, 'F2', muted);
    pageTwo.push(`${brass} RG 1 w 48 733 m 564 733 l S`);
    addPdfText(pageTwo, 'ESSENTIAL FIRST STEPS', 48, 695, 9, 'F2', brass);
    addPdfText(pageTwo, 'Before you begin', 48, 657, 26, 'F2', walnut);
    addPdfText(pageTwo, 'Always follow the installation guide provided with your fixture.', 48, 632, 10, 'F1', muted);

    data.universalSafety.forEach((item, index) => {
      const y = 584 - (index * 72);
      pageTwo.push(`${pale} rg 48 ${y - 15} 34 34 re f`);
      addPdfText(pageTwo, String(index + 1).padStart(2, '0'), 57, y - 3, 9, 'F2', rust);
      addWrappedPdfText(pageTwo, item, 102, y + 2, 450, 10.5, 15, 'F1', walnut);
    });

    pageTwo.push(`${walnut} rg 48 112 516 128 re f`);
    addPdfText(pageTwo, 'STOP AND CONTACT MERGE', 70, 207, 9, 'F2', brass);
    addWrappedPdfText(pageTwo, profile.caution, 70, 181, 470, 11, 16, 'F1', softWhite);
    addWrappedPdfText(pageTwo, 'Contact Merge about new cracks, loose fittings, lifting coatings, corrosion, sharp chips, or any electrical problem.', 70, 140, 470, 9, 13, 'F1', softWhite);
    pageTwo.push(`${brass} RG 0.8 w 48 54 m 564 54 l S`);
    addPdfText(pageTwo, 'mergelighting.com', 48, 35, 8, 'F1', muted);
    addPdfText(pageTwo, 'Material Care & Maintenance', 236, 35, 8, 'F1', muted);
    addPdfText(pageTwo, '2 / 2', 535, 35, 8, 'F2', walnut);

    return buildPdfFile(pageOne, pageTwo, image);
  }

  function createGuideFilename(material, selectedFinish) {
    const toFilenamePart = (value) => asciiPdfText(value)
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/gi, '_')
      .replace(/^_+|_+$/g, '');
    const materialPart = toFilenamePart(material.name);
    const finishPart = toFilenamePart(selectedFinish ? selectedFinish.label : 'General care');
    return `Merge_${materialPart}_${finishPart}_Care_Guide.pdf`;
  }

  function loadMaterialImageForPdf(documentRef, windowRef) {
    const imageElement = documentRef.querySelector('.material-swatch__image');
    if (!imageElement || !imageElement.complete || !imageElement.naturalWidth) return null;

    const canvas = documentRef.createElement('canvas');
    canvas.width = 640;
    canvas.height = 640;
    const context = canvas.getContext('2d', { alpha: false });
    if (!context) return null;

    context.fillStyle = '#fffefa';
    context.fillRect(0, 0, canvas.width, canvas.height);
    try {
      context.drawImage(imageElement, 0, 0, canvas.width, canvas.height);
      const encoded = canvas.toDataURL('image/jpeg', 0.9).split(',')[1];
      if (!encoded) return null;
      const binary = windowRef.atob(encoded);
      const bytes = new Uint8Array(binary.length);
      for (let index = 0; index < binary.length; index += 1) {
        bytes[index] = binary.charCodeAt(index);
      }
      return {
        bytes,
        width: canvas.width,
        height: canvas.height,
      };
    } catch (error) {
      return null;
    }
  }

  function createCareGuideDownload(documentRef, windowRef, data, view) {
    const image = loadMaterialImageForPdf(documentRef, windowRef);

    const createdOn = new Date().toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
    const pdf = buildCareGuidePdf({
      data,
      material: view.selectedMaterial,
      selectedFinish: view.selectedFinish,
      finishNote: view.finishNote,
      image,
      createdOn,
    });
    const blob = new windowRef.Blob([pdf], { type: 'application/pdf' });
    return {
      url: windowRef.URL.createObjectURL(blob),
      filename: createGuideFilename(view.selectedMaterial, view.selectedFinish),
    };
  }

  function renderCategories(data, state) {
    const options = [{ id: 'all', label: 'All materials' }, ...data.categories];
    return options.map((category) => {
      const selected = category.id === state.category;
      return `
        <button class="category-tab" type="button" data-category="${escapeHtml(category.id)}" aria-pressed="${selected}">
          ${escapeHtml(category.label)}
        </button>`;
    }).join('');
  }

  function renderFinishControls(data, material, selectedFinish) {
    if (!material.finishIds.length) {
      return '<p class="finish-fallback">No finish selection is needed for this material.</p>';
    }

    const buttons = material.finishIds.map((finishId) => {
      const finish = data.finishes.find((item) => item.id === finishId);
      const selected = selectedFinish && selectedFinish.id === finishId;
      return `
        <button class="finish-chip" type="button" data-finish-id="${escapeHtml(finishId)}" aria-pressed="${Boolean(selected)}">
          ${escapeHtml(finish.label)}
        </button>`;
    }).join('');

    return `
      <div class="finish-selector" aria-label="Choose a surface finish">
        <p class="finish-selector__label">Surface finish</p>
        <div class="finish-selector__options">${buttons}</div>
      </div>`;
  }

  function renderCarePanel(data, material, selectedFinish, finishNote) {
    const profile = data.careProfiles[material.careProfile];
    const careItems = [
      ['01', 'Routine care', profile.routine, 'routine'],
      ['02', 'Spots & spills', profile.marks, 'marks'],
      ['03', 'Avoid', profile.avoid, 'avoid'],
      ['04', 'Natural aging', profile.ageing, 'ageing'],
    ];

    return `
      <article class="care-panel" id="care-${escapeHtml(material.id)}" aria-labelledby="trigger-${escapeHtml(material.id)}">
        <header class="care-panel__header">
          <div>
            <p class="care-panel__category">${escapeHtml(categoryLabel(data, material.category))}</p>
            <h3>${escapeHtml(material.name)}</h3>
          </div>
          <span class="material-swatch" aria-hidden="true">
            <img
              class="material-swatch__image"
              src="${escapeHtml(assetBase)}merge-care-sample-${escapeHtml(materialSampleFilename(material.id))}"
              alt=""
              width="180"
              height="180"
              loading="lazy"
            >
          </span>
        </header>
        ${renderFinishControls(data, material, selectedFinish)}
        <div class="finish-note">
          <p class="finish-note__label">${selectedFinish ? escapeHtml(selectedFinish.label) : material.finishIds.length ? 'Finish unknown' : 'General care'}</p>
          <p>${escapeHtml(finishNote)}</p>
        </div>
        <div class="care-download">
          <a class="button button--primary" id="download-guide" aria-disabled="true">Download ${escapeHtml(material.name)} care guide (PDF)</a>
          <span class="visually-hidden" id="download-status" role="status" aria-live="polite"></span>
        </div>
        <div class="care-grid">
          ${careItems.map(([number, title, body, variant]) => `
            <section class="care-item care-item--${variant}">
              <span class="care-item__number" aria-hidden="true">${number}</span>
              <h4>${escapeHtml(title)}</h4>
              <p>${escapeHtml(body)}</p>
            </section>`).join('')}
        </div>
        <aside class="caution-note">
          <p class="caution-note__label">Stop and contact Merge</p>
          <p>${escapeHtml(profile.caution)}</p>
        </aside>
      </article>`;
  }

  function renderResults(data, view) {
    if (!view.materials.length) {
      return `
        <div class="empty-state">
          <p class="eyebrow">Nothing found</p>
          <h3>No matching material found</h3>
          <p>Try a broader search, view all materials, or contact Merge before using any cleaner.</p>
          <button class="button button--dark" type="button" data-reset-catalog>View all materials</button>
        </div>`;
    }

    return `
      <div class="material-browser__grid">
        ${view.materials.map((material) => {
          const selected = Boolean(view.selectedMaterial && material.id === view.selectedMaterial.id);
          return `
            <div class="material-entry${selected ? ' is-selected' : ''}">
              <button class="material-trigger" id="trigger-${escapeHtml(material.id)}" type="button" data-material-id="${escapeHtml(material.id)}" aria-expanded="${selected}" aria-controls="care-${escapeHtml(material.id)}">
                <span>
                  <span class="material-trigger__name">${escapeHtml(material.name)}</span>
                  <span class="material-trigger__meta">${escapeHtml(categoryLabel(data, material.category))}</span>
                </span>
                <span class="material-trigger__indicator" aria-hidden="true">${selected ? '−' : '+'}</span>
              </button>
              ${selected ? renderCarePanel(data, material, view.selectedFinish, view.finishNote) : ''}
            </div>`;
        }).join('')}
      </div>`;
  }

  function init(documentRef, windowRef, data, catalog) {
    if (!documentRef) return null;

    const sectionRoot = documentRef.querySelector('.merge-care');
    assetBase = sectionRoot ? sectionRoot.dataset.assetBase : '';

    const results = documentRef.getElementById('material-results');
    const tabs = documentRef.getElementById('category-tabs');
    const search = documentRef.getElementById('material-search');
    const clearSearch = documentRef.getElementById('clear-search');
    const resultCount = documentRef.getElementById('result-count');
    let downloadLink = documentRef.getElementById('download-guide');

    if (!data || !catalog || !results || !tabs || !search) {
      if (results) results.innerHTML = '<p class="error-state">The care library could not be loaded. Please use the universal guidance below and contact Merge before cleaning.</p>';
      return null;
    }

    const state = createInitialState();
    let currentView = null;
    let downloadUrl = null;

    syncCarePanelStickyTop(documentRef);
    windowRef.addEventListener('resize', () => syncCarePanelStickyTop(documentRef));

    function clearDownload() {
      if (downloadUrl) {
        windowRef.URL.revokeObjectURL(downloadUrl);
        downloadUrl = null;
      }
      if (!downloadLink) return;
      downloadLink.removeAttribute('href');
      downloadLink.removeAttribute('download');
      downloadLink.setAttribute('aria-disabled', 'true');
    }

    function prepareDownload(expectedMaterialId) {
      if (!currentView.selectedMaterial || currentView.selectedMaterial.id !== expectedMaterialId) {
        clearDownload();
        return;
      }

      const prepared = createCareGuideDownload(documentRef, windowRef, data, currentView);
      if (downloadUrl) windowRef.URL.revokeObjectURL(downloadUrl);
      downloadUrl = prepared.url;
      downloadLink.href = prepared.url;
      downloadLink.download = prepared.filename;
      downloadLink.textContent = `Download ${currentView.selectedMaterial.name}${currentView.selectedFinish ? ` · ${currentView.selectedFinish.label}` : ''} Care Guide (PDF)`;
      downloadLink.setAttribute('aria-disabled', 'false');
    }

    function focusAfterRender(selector) {
      windowRef.requestAnimationFrame(() => {
        const element = documentRef.querySelector(selector);
        if (element) element.focus();
      });
    }

    function render() {
      currentView = buildViewModel(data, catalog, state);
      state.selectedMaterialId = currentView.selectedMaterial ? currentView.selectedMaterial.id : null;
      state.selectedFinishId = currentView.selectedFinish ? currentView.selectedFinish.id : null;
      tabs.innerHTML = renderCategories(data, state);
      results.innerHTML = renderResults(data, currentView);
      downloadLink = documentRef.getElementById('download-guide');
      resultCount.textContent = `${currentView.materials.length} ${currentView.materials.length === 1 ? 'material' : 'materials'}`;
      clearSearch.hidden = !state.query;
      const selectedMaterialId = currentView.selectedMaterial ? currentView.selectedMaterial.id : null;
      if (!selectedMaterialId) {
        clearDownload();
        return;
      }

      prepareDownload(selectedMaterialId);
      const swatchImage = documentRef.querySelector('.material-swatch__image');
      if (swatchImage && !swatchImage.complete) {
        swatchImage.addEventListener('load', () => prepareDownload(selectedMaterialId), { once: true });
      }
    }

    search.addEventListener('input', (event) => {
      state.query = event.target.value;
      render();
    });

    clearSearch.addEventListener('click', () => {
      state.query = '';
      search.value = '';
      render();
      search.focus();
    });

    tabs.addEventListener('click', (event) => {
      const button = event.target.closest('[data-category]');
      if (!button) return;
      state.category = button.dataset.category;
      render();
      focusAfterRender(`[data-category="${state.category}"]`);
    });

    results.addEventListener('click', (event) => {
      const downloadButton = event.target.closest('#download-guide');
      if (downloadButton) {
        if (downloadButton.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        const downloadStatus = documentRef.getElementById('download-status');
        if (downloadStatus) downloadStatus.textContent = 'Your download should begin shortly.';
        return;
      }

      const resetButton = event.target.closest('[data-reset-catalog]');
      if (resetButton) {
        state.query = '';
        state.category = 'all';
        search.value = '';
        render();
        search.focus();
        return;
      }

      const materialButton = event.target.closest('[data-material-id]');
      if (materialButton) {
        const materialId = materialButton.dataset.materialId;
        if (isMobileLayout(windowRef) && state.selectedMaterialId === materialId) {
          state.selectedMaterialId = null;
          state.selectedFinishId = null;
          render();
          focusAfterRender(`[data-material-id="${materialId}"]`);
          return;
        }

        state.selectedMaterialId = materialId;
        const material = catalog.getMaterial(data.materials, state.selectedMaterialId);
        state.selectedFinishId = material && material.finishIds.length ? material.finishIds[0] : null;
        render();
        focusAfterRender(`[data-material-id="${materialId}"]`);
        return;
      }

      const finishButton = event.target.closest('[data-finish-id]');
      if (finishButton) {
        state.selectedFinishId = finishButton.dataset.finishId;
        render();
        focusAfterRender(`[data-finish-id="${state.selectedFinishId}"]`);
      }
    });

    render();
    return { state, render, getView: () => currentView };
  }

  return {
    buildViewModel,
    buildCareGuidePdf,
    createGuideFilename,
    createInitialState,
    getCarePanelStickyTop,
    isMobileLayout,
    init,
  };
}));
  } catch(e) { console.error(e); }
})();

})();
